export default __webpack_public_path__ + "images/8b1abecfbc93c36930abfe9c0732b879.svg";